import React from 'react';
import '../styles/App.css';

/**
 * Class used to render the list of functions based on controller selection
 *
 * @author Ethan Jones
 */
class FunctionTable extends React.Component{

    state ={
        isSingleFunction: null
    }
    /**
     * Iterates through list of controller functions, inserting them into a table and rendering them. If there is
     * only one function, it is automatically selected
     *
     * @returns {*}
     */
    renderFunctionData(){
        return(
            this.props.functions && this.props.functions.map((data, index) =>(
                <tr key = {index}>
                    <td  id ={"func"+index} onClick = {()=> this.props.handleFunctionClick(data[0].functionLabel, index, false)}
                        className={(this.props.functionIndex === index || this.props.functions.length === 1) ? "selectedRow" :""}>
                        {data[0].functionLabel}
                    </td>
                </tr>
            ))
        )
    }

    componentDidMount() {
        this.handleSingleFunctionClick().then()
    }

    async handleSingleFunctionClick(){
        if(this.props.functions.length > 1)
            return
        let functionRow = document.getElementById("func0")
        if(null !== functionRow){
            functionRow.click()
        }
    }

    /**
     * Main render method for function table class
     * @returns {*}
     */
    render(){

        return(

            <div>
                <label className={"FunctionTableLabel"}>
                    Select Function
                </label>
                <div className={"FunctionTableContainer"}>
                    <table >
                        {this.renderFunctionData()}
                    </table>
                </div>
            </div>
        )
    }


}

export default FunctionTable;